import { CheckCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import classNames from "classnames";
import classes from "./styles.module.css";
import { SIDE_MAP } from "@services/api";

export const BankOrderProgress = ({ carts, currentCart, side }) => {
  return (
    <div className={classes.progress}>
      {carts.map((cart) => (
        <Tooltip key={cart.code} title={cart.name}>
          <div
            className={classNames(classes.cart, {
              [classes.bank]: side === "BANK",
              [classes.agent]: side === "AGENT",
              [classes.client]: side === "CLIENT",
              [classes.active]: cart.code >= currentCart,
              [classes.lastActive]: cart.code === currentCart,
            })}
          >
            {cart.code > currentCart && <CheckCircleOutlined style={{ color: "white" }} />}
            {cart.code === currentCart && <span className={classes.side}>{SIDE_MAP[side]}</span>}
          </div>
        </Tooltip>
      ))}
    </div>
  );
};
